<template>
  <div class="article-box">
    <h5 class="article_title">帮助中心</h5>
    <hr>
    <div class="article_content" v-html="data">
      <!--<p class="title">
        <strong>
          <img src="../assets/img/9b217b50c097219b81abde61aa8a79c2.png" title="1.png" alt="1.png">&nbsp;
          <span style="font-size: 16px;">股票配资为什么一定要用配资公司提供的账户？</span>
        </strong>
      </p>
      <p class="content">
        <span style="font-size: 16px;">答：首先投资者重视账户问题，最主要的原因是这关系到资金安全的保障。相信做过配资的朋友们都十分清楚，和正规配资公司合作，合作生意账户都是由配资公司来提供的，这是行规之一。而刚接触配资的朋友们对这个比较敏感，担心配资公司把他们的钱卷跑了。协作生意账户由配资公司来提供是十分正常的，不论你和哪家规范的配资公司进行协作，都是如此。之所以必须运用配资公司提供的协作生意账户，是由于配资公司需要对合作两边的资金进行风险监控，在你操作不佳的时分会有风控人员及时提示你操控危险。虽然合作账户是由配资公司指定的，但合作账户完全由投资者进行操作，盈余都归操作方所有，当然，危险也都由操作方承担</span>
      </p>
      <p class="title">
        <strong>
          <img src="../assets/img/f229243b10a101a0fed3494e6113c8d4.png" title="2.png" alt="2.png">
          <span style="font-size: 16px;">股票配资市场中都是把钱打给配资公司账户为基本要求的，经常会有好多客户问，股票配资公司为什么不能把钱打到自己账户操作呢？</span>
        </strong>
      </p>
      <p class="content">
        <span style="font-size: 16px;">答：股票配资用配资公司提供的账户主要是为了做风控。独立户，有资方指定券商，这种对接的都是上千万的账户。小资金的要用分仓软件把他们的大账户资金分出来给股民朋友操作，肯定要用他们的账户。资管户更简单，发的是信托产品，账户已经开好了，剩下的就是分仓给股民朋友操作。用的都是配资公司的账户。</span>
      </p>
      <p class="title">
        <strong>
          <img src="../assets/img/68c26087f3c4b1db7d8b99ec66aeae20.png" title="3.png" alt="3.png">
          <span style="font-size: 16px;">其次是配资公司往往要出几倍于客户的资金，打个比方，配资客户出资10万最高能在配资公司配50万，客户虽然担心自己10万本金的安全，但是配资公司何尝不担心自己大于客户5倍的50万资金的资金安全呢？</span>
        </strong>
      </p>
      <p class="content">
        <span style="font-size: 16px;">答：其次股票配资公司一般都是以公司性质来做配资业务的，无论是工商局注册信息，还是自己的公司成本都是比客户本身个人名义要牢靠的多，所以两者相比肯定是选择把资金放在配资公司更牢靠些的。 最后最主要的就是股票配资这个融资模式由于没有任何抵押，账户资金的风险控制都是需要人为的监控的，股票配资公司都是有自己的专人盯着账户的，所以为了保障双方的资金风险，单是风控这点就肯定只能用配资公司的账户来操作了。 保证资金安全，其实说到头来还是担心配资公司靠不靠谱，看看配资公司的规模，门面，可以上网搜一搜公司实力 ，最好实地去考察一下，和配资人员仔细阅读合同，确认每一个环节是否合理合法，是否有漏洞或者隐藏条款或者其他解读。 最好找历史久、规模大、口碑好的配资公司，一般不会有问题，毕竟配资公司的赢利点不在收取本金。</span>
      </p>
      <p class="title">
        <strong>
          <img src="../assets/img/aae1394c092e1cc52b87ffa82a9472f3.png" title="4.png" alt="4.png">
          <span style="font-size: 18px;">什么是金融杠杆原理？</span>
        </strong>
      </p>
      <p class="content">
        <span style="font-size: 16px;">答：在金融衍生品中，资金杠杆原理与这个规则本质上类似，都是以一定比率的保证金撬动大资金，是金融业中最常见的投资手段，例如外汇、期货交易、黄金等贵金属交易。其中，黄金贵金属的杠杆比例最高，可达1:100，相当于100万的黄金，你只用给1万就可以交易，假设黄金上涨到105万，你就赚了5万&nbsp;</span>
      </p>
      <p class="title">
        <strong>
          <img src="../assets/img/9e143ae6bc6056828426ec4c3b01b507.png" title="5.png" alt="5.png">&nbsp;<span style="font-size: 18px;">为什么杠杆原理的投资要注意止损？</span>
        </strong>
      </p>
      <p class="content">
        <span style="">答：那么，这时就会有人问，杠杆原理既然能放大收益，也能放大亏损，那且不很危险？诚然，风险与收益总是相对的，试问哪个投资没有风险？就算你现在买了一套房，也未必能确保未来的房价是否还会上涨，所以哪有投资是没有风险的？关键就在于你是否懂得控制。</span>
      </p>
      <p class="title">
        <strong>
          <img src="../assets/img/faff5f7c2337279aaabaf61b8b3ddf74.png" title="6.png" alt="6.png">
          <span style="font-size: 18px;">股票配资发生纠纷如何处理？</span>
        </strong>
      </p>
      <p class="content">
        <span>答：首先，我们要弄清配资的实质：配资业务实质上属于借贷关系，在配资双方发生纠纷的 案例中，有判例判决借款人应偿还借款本金及利息。该判例的判决在一定程度上认可了股票配资的合法性。投资者在配资前一定要把合同全部了解清楚，签署的文件资料需要全部做保留，以免在后续发生纠纷时没有证据。 随着国家经济的不断发展，我国的投资领域也得到了很大的繁荣，很多人都加入到了投资的行列。而且现在即使大家的资金不够充足，也依然可以通过配资的方式进行投资。现在的投资项目有很多，其中的股票是比较受到大家欢迎的。 配资就是配资公司向投资者提供一定杠杆比例的资金，专门是用来炒股的，而配资者只需要向配资公司支付一定的利息就可以了。 投资者从事的配资活动，从理论上来讲，一般较为分散，资金量不大，尚不致对金融市场产生不良影响，因此，只要不违反民法通则、合同法及国家金融法规的禁止性规定，当事人的意思自治应受到尊重，所签订的配资协议也可认定为有效。 配资如果是双方约定的的规则，比如平仓行为，配资公司设置平仓线主要是为了防范风险，万一配资者的账户到了平仓线，配资系统是有权将账户进行股票平仓的，最后账户盈亏由配资者自负。要是没来得及追加保证金，是不是就不能操作的了。到了平仓线，确实不可与继续操作的，而且一旦在次日的开盘前如果没有追加保证金是会立马平仓。请注意的是，是到第二天也就是次日开盘前。这说明还是给配资者预留了一定的时间，而且配资公司也会提前通知配资者，以免被平仓了。 如果投资者个人在平仓行为发生后认为不合理，这个就需要配资双方协商；如果是配资公司违约，投资者在协商不行的情况下可以选择起诉； 如果是投资者的盈利或者本金在提现时出现问题或者提现出现推迟，配资公司出现各种借口和理由推脱的时候，投资者就需要提高警惕，立马去配资公司查看情况，或者可以选择报警；如果出现电话不通，账户无缘故冻结的情况，投资者无论如何都要马上报案，当然这个时候也有可能配资公司已经跑路了。 提醒：作为投资者一定要学会保护我们自己的合法权益，配资行为就是属于民间借贷，如果出现不公平不合理的时候，投资者要及时处理，维护自己的利益，不要因为担心让家人知道，觉得炒股亏钱丢人而不了了之 股票配资可以通过设置平仓线来控制交易风险。例如，此时我们19元买入一只股票，平仓线是17元，那么当该股价格下跌至17元时，系统就会帮你自动平仓，这样就能把亏损控制在一定范围内了。 最后，提醒大家：在你了解资金杠杆原理带来的好处时，如果你都想进入金融市场分一杯羹，不仅要学会止损，更要有相当的投资基础，只有把根基打好了，交易起来才能更得心应手。</span>
      </p>
      <p>
        <br>
      </p>-->
    </div>
  </div>
</template>

<script>
    export default {
      name: "helpcenter",
      data(){
        return{
          data:''
        }
      },
      methods:{
        getData(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                'nozzle': 'protocol',
                'type': 17,
              }
            })  .then(res => {
            let resData = res.data;
            if (res.data.code == 1) {
              that.data = resData.data;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
        }
      },
      mounted() {
        this.getData();
      }
    }
</script>

<style scoped>
  .article_title{
    font-size: 20px;
    font-weight: 500;
  }
  .article_content>>img{
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/helpcenter.vue